import { Actions } from 'vuex-smart-module';
import { ResponseStatuses } from '@/enums';
import { AxiosResponse } from 'axios';
import { Filters, FiltersPagination } from '@/types';
import { NotificationsService } from '../services';
import NotificationsState from './state';
import NotificationsMutations from './mutations';
import NotificationsGetters from './getters';
import { Notifications } from '../types';

const notificationsService = new NotificationsService();

export default class NotificationsActions extends Actions<
  NotificationsState,
  NotificationsGetters,
  NotificationsMutations,
  // eslint-disable-next-line no-use-before-define
  NotificationsActions
> {
  async get_notifs() {
    this.mutations.TOGGLE_LOADING_NOTIFS(true);

    try {
      // const { sortBy = [], sortDesc = [] } = this.state.table_options;
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;

      const payload: FiltersPagination<Filters> = {
        filters: this.state.filters,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      const { data, meta } = await notificationsService.get_notifs(payload);

      this.mutations.SET_NOTIFICATIONS(data.items);
      this.mutations.SET_SECTIONS_NOTIFICATIONS_FILTER(data.sections);
      this.mutations.SET_NUMBER_UNREAD_NOTIFICATION(data.number_unread_notifications);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.TOGGLE_LOADING_NOTIFS(false);
    }
  }

  async get_last_notifs(is_without_news?: boolean) {
    try {
      const { data } = await notificationsService.get_last_notifs(is_without_news);

      if (is_without_news) {
        this.mutations.SET_LAST_NOTIFICATIONS_IS_WITHOUT_NEWS(data.items);
      } else {
        this.mutations.SET_LAST_NOTIFICATIONS(data.items);
        this.mutations.SET_NUMBER_UNREAD_NOTIFICATION(data.number_unread_notifications);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async get_last_news() {
    try {
      const { data } = await notificationsService.get_last_news();

      this.mutations.SET_LAST_NEWS(data.items);
    } catch (error) {
      console.log(error);
    }
  }

  async get_user_notifs() {
    try {
      const { data } = await notificationsService.get_user_notifs();

      this.mutations.SET_USER_NOTIFS(data.items);
    } catch (error) {
      console.log(error);
    }
  }

  async save_user_notifs() {
    const payload = {
      items: this.state.user_notifs,
    };

    try {
      const { code } = await notificationsService.save_user_notifs(payload);

      return code;
    } catch (error) {
      console.log(error);
    }
  }

  async reading_notifs(ids: Array<number>) {
    if (!ids?.length) {
      return;
    }

    try {
      const { sortBy = [], sortDesc = [] } = this.state.table_options;
      const { current_page, limit } = this.state.pagination_props;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.filters,
        pagination: {
          limit,
          page: current_page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      await notificationsService.reading_notifs(ids, payload);

      this.dispatch('get_popup_notifications');
      this.dispatch('get_last_notifs', false);
      this.dispatch('get_last_notifs', true);
      this.dispatch('get_last_news');
      this.mutations.SET_READ_NOTIFICATIONS(ids);
      this.mutations.SET_NUMBER_UNREAD_NOTIFICATION(this.state.number_unread_notifications);
    } catch (error) {
      console.log(error);
    }
  }

  async reading_notify(id: number) {
    try {
      const arrayID = [id];

      await notificationsService.reading_notifs(arrayID, []);
    } catch (error) {
      console.log(error);
    }
  }

  async get_unread_entities() {
    try {
      const { data } = await notificationsService.get_unread_entities();

      this.mutations.SET_UNREAD_ENTITIES(data.items);
    } catch (error) {
      console.error(error);
    }
  }

  async update_unread_entities() {
    try {
      const { code } = await notificationsService.update_unread_entities(this.state.unread_entities);

      return code;
    } catch (error) {
      console.error(error);
    }
  }

  async get_popup_notifications() {
    try {
      const { data, code } = await notificationsService.get_popup_notifications();

      this.mutations.SET_POPUP_NOTIFICATIONS(data.items);
    } catch (error) {
      console.error(error);
    }
  }
}
